import { connect } from 'react-redux';

import { SsrTest } from './component';

export const ConnectedSsrTest = connect(() => ({}))(SsrTest);
